export const NodeRoles = {
  // do not remove a Role unless it has been removed from ALL nodes in the fleet
  // use format of Formal Name: role_id
  // also add to github.com/agrology/go-types-fleet/node/roles.go
  "Arbiter v0": "arbiter.v0",
  "Sentinel": "sentinel",
  "Other": "other",
}
